import { defineMessages } from 'react-intl';

export const texts = defineMessages({
  notificationTitle: {
    id: 'UnreadMessagesListener.notificationTitle',
    description: 'Notification title',
    defaultMessage: 'Nytt meddelande',
  },
});
